export const job_title = 'Job Details';
export const job_id = '0';
export const industry_name = 'Oil & Gas';
export const location = 'Denver,CO';
export const job_type = 'Executive';
export const pay_rate = '';
